function getNotifications (filter) {
        return window.Vue.$http.post(`${process.env.VUE_APP_API_SERVER}/notificacao/getNotifications`, filter)
                    .then(resp => {
                        if (resp.data.success) {
                            return Promise.resolve(resp.data)
                        } else {
                            return Promise.reject(resp.data)
                        }
                    })
    }

function getLatestNotifications () {
    return window.Vue.$httpNoInterceptor.get(`${process.env.VUE_APP_API_SERVER}/notificacao/getLatestNotifications`)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })
}

function setNotificationRead (ids) {
    return window.Vue.$http.post(`${process.env.VUE_APP_API_SERVER}/notificacao/markAsRead`, ids)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })
}

function setNotificationUnread (ids) {
    return window.Vue.$http.post(`${process.env.VUE_APP_API_SERVER}/notificacao/markAsUnread`, ids)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })
}

function getMenuPerfil () {
    return window.Vue.$httpCookiesOnly.get(`${process.env.VUE_APP_UPFYGATE}/auth/menusperfil`)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })          
}

function getMenu () {
    return window.Vue.$httpCookiesOnly.get(`${process.env.VUE_APP_UPFYGATE}/auth/menus`)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })
}

// Marca que o usuário já clicou no módulo (some a badge "Novo"). Idempotente; quem chama
// ignora a resposta e os erros.
function marcarModuloVisto (chave) {
    return window.Vue.$httpCookiesOnly.post(`${process.env.VUE_APP_UPFYGATE}/auth/menus/visto/${encodeURIComponent(chave)}`, null, { skipGlobalErrorNotification: true })
}

function getRestricaoHorarioAtiva () {
    return window.Vue.$httpCookiesOnly.get(`${process.env.VUE_APP_UPFYGATE}/auth/restricaoHorarioAtiva`)
                .then(resp => {
                    if (resp.data.success) {
                        return Promise.resolve(resp.data)
                    } else {
                        return Promise.reject(resp.data)
                    }
                })
}

export { 
    getNotifications,
    getLatestNotifications,
    setNotificationRead,
    setNotificationUnread,
    getMenuPerfil,
    getMenu,
    marcarModuloVisto,
    getRestricaoHorarioAtiva
}
